import { useState } from "react";
import { Input } from "../Input/Input";
import { Dropdown } from "../Dropdown/Dropdown";
// import { Checkbox } from "../Checkbox/Checkbox";
import { Button } from "../buttons/Button/Button";
import { CheckForm } from "../CheckForm/CheckForm";
import { Link } from "../Link/Link";
import { senderCategory } from "./assets";
import "./form.css";

export const CTAForm = () => {
  const [agreed, setAgreed] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    mail: "",
    phone: "",
    organization: "",
    sender: "",
    message: "",
    agreement: "",
  });
  

  const onAgreed = (value) => {
    setAgreed(value)
  }
  const handleInputChange = (e) => {
    const { name: inputName, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [inputName]: value,
    }));
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
  };

  return (
    <form onSubmit={onSubmitForm} className="form">
      <div className="inputs-line">
        <label>
          <span className="body3">YOUR NAME*</span>
          <Input
            placeholder="Your name"
            name="name"
            onChange={handleInputChange}
          />
        </label>
        <label>
          <span className="body3">E-MAIL*</span>
          <Input
            placeholder="Your E-mail"
            name="mail"
            onChange={handleInputChange}
          />
        </label>
      </div>
      <div className="inputs-line">
        <label>
          <span className="body3">PHONE</span>
          <Input placeholder="Your phone number" name="phone" />
        </label>
        <label>
          <span className="body3">ORGANIZATION</span>
          <Input placeholder="Organization" name="organization" />
        </label>
      </div>
      <div className="form-dropdown">
        <label>
          <span className="body3">Select a sender category*</span>
          <Dropdown options={senderCategory} />
        </label>
      </div>
      <label>
        <span className="body3">YOUR MESSAGE*</span>
        <textarea
          className="textarea"
          placeholder="Please enter your message"
          name="message"
        ></textarea>
      </label>
      <div className="submit-wrapper">
        <div className="checkbox-wrapper">
          <CheckForm onClick={onAgreed}>
            <span>I agree to the</span>{" "}
            <Link href="https://www.google.com">Terms of Use</Link>
            <span> and</span> <Link href="#">Privacy Policy</Link>
          </CheckForm>
        </div>
        <div className="submit-button">
          <Button type={`${!agreed && "disabled"} submit`}>SUBMIT</Button>
        </div>
      </div>
    </form>
  );
};
